<footer class="fixed inset-x-0 bottom-0">
  <wen-nft-selection-toolbar></wen-nft-selection-toolbar>
</footer>
